import { formatString } from "@@common";
import getNestedPropertyValue from "../../../common/getNestedPropertyValue";
import { PropertyDisplayModel } from "../../Models/PropertyDisplayModel";
import { isEmptyDate } from "../../Utils/displayFormatting";
import formatValue from "./formatValue";

export { isEmptyDate };

const formatPropertyValue = (
  data: Record<string, any>,
  property: PropertyDisplayModel,
  observedPaths?: string[],
  lookupDisplayItem?: any,
  phoneNumberFormat?: string,
  currencyCode?: string
): string => {
  if (!!property.ValueTemplate) {
    return formatString(property.ValueTemplate, data, observedPaths);
  }

  // Handle lookup fields
  if (property.Lookup) {
    if (property.Field) {
      const fieldValue = getNestedPropertyValue(property.Field, data);

      // Collect observed path if requested
      if (observedPaths !== undefined) {
        observedPaths.push(property.Field);
      }

      // If the field value is an object (the item), format it using ItemLabel
      if (fieldValue && typeof fieldValue === "object") {
        const itemLabel = property.Lookup.ItemLabel || "{Label}";
        return formatString(itemLabel, fieldValue);
      }

      // Otherwise just display the value as-is
      return fieldValue?.toString() || "";
    }

    // When Lookup is defined but Field is not, use the pre-loaded lookup item if available
    if (lookupDisplayItem) {
      const itemLabel = property.Lookup.ItemLabel || "{Label}";
      return formatString(itemLabel, lookupDisplayItem);
    }

    // No item loaded yet, return empty
    return "";
  }

  if (!property.Field) {
    return "";
  }

  // Support dot notation for nested property access (e.g., "user.name" accesses data.user.name)
  const value: any = getNestedPropertyValue(property.Field, data);

  // Collect observed path if requested
  if (observedPaths !== undefined) {
    observedPaths.push(property.Field);
  }

  return formatValue(value, property.Format, currencyCode, phoneNumberFormat);
};

export default formatPropertyValue;
